module.exports = __webpack_public_path__ + "img/edit-money.f3d0796c.svg";